import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import {
  Row,
  Col,
  Card,
  CardBlock,
  CardText,
  CardImg,
  CardTitle,
  Button,
} from 'reactstrap';

@inject('appState')
@observer
class HomeFeatures extends Component {
  render() {
    return (
      <div>
        <Row>
          <Col>
            <h2
              style={{ letterSpacing: '5px' }}
              className="h1 px-3 pt-5 text-center text-uppercase"
            >
              Spotlight
            </h2>
          </Col>
        </Row>
        <Row className="pb-4">
          <Col className="py-2" lg="4" xs="12">
            <Card inverse>
              <CardImg
                width="100%"
                src="/assets/carousel/ACITWM_Final.png"
                alt="Another Cabin in the Woods Movie"
              />
              <CardBlock>
                <CardTitle>Another Cabin</CardTitle>
                <CardText>
                  In this tongue-in-cheek spoof, horror-savvy characters are trapped in yet another cabin in the woods, where they are forced to navigate murder and red herrings to uncover who will stop at nothing for their twisted happily ever after.
                </CardText>
                <Button
                  onClick={
                    () =>
                      this.props.appState.openAndPlay({
                        title: 'Another Cabin in the Woods Movie',
                        url: 'https://www.youtube.com/watch?v=8MdbG2GXJ7M',
                      })
                  }
                  outline
                  className="m-2"
                  size="lg"
                >
                  <i className="fa fa-play pr-2" />Watch Trailer
                </Button>
                <Button
                  onClick={
                    () =>
                      window.open(
                        'https://tubitv.com/movies/100028865/another-cabin-in-the-woods-movie',
                        '_blank',
                      )
                  }
                  outline
                  size="lg"
                  color="success"
                  className="m-2"
                >
                  <i className="fa fa-play pr-2" />AVAILABLE ON TUBI
                </Button>
              </CardBlock>
            </Card>
          </Col>
          <Col className="py-2" lg="4" xs="12">
            <Card inverse>
              <CardImg
                width="100%"
                src="/assets/carousel/UD_MainPoster.png"
                alt="Unknown Dimension"
              />
              <CardBlock>
                <CardTitle>Unknown Dimension</CardTitle>
                <CardText>
                  A deep dive into the making of the "Paranormal Activity" films with first time ever interviews with cast and crew, never-before-seen footage from the movies, and a preview of the seventh installment of the franchise: "Paranormal Activity: Next of Kin."
                </CardText>
                <Button
                  onClick={
                    () =>
                      this.props.appState.openAndPlay({
                        title: 'Unknown Dimension',
                        url: 'https://vimeo.com/882755185',
                      })
                  }
                  outline
                  className="m-2"
                  size="lg"
                >
                  <i className="fa fa-play pr-2" />Watch Trailer
                </Button>
                <Button
                  onClick={
                    () =>
                      window.open(
                        'https://www.paramountmovies.com/movies/unknown-dimension-the-story-of-paranormal-activity',
                        '_blank',
                      )
                  }
                  outline
                  size="lg"
                  color="success"
                  className="m-2"
                >
                  <i className="fa fa-play pr-2" />Available on Paramount+
                </Button>
              </CardBlock>
            </Card>
          </Col>
          <Col className="py-2" lg="4" xs="12">
            <Card inverse>
              <CardImg
                width="100%"
                src="/assets/carousel/HHOPoster.png"
                alt="HHLLC ORIGINS: THE CARMICHAEL MANOR Poster"
              />
              <CardBlock>
                <CardTitle>HELL HOUSE LLC ORIGINS</CardTitle>
                <CardText>
                  Internet sleuths travel to Carmichael Manor, site of the 1989 Carmichael family murders. After four nights, the group was never heard from again. What is discovered on their footage is even more disturbing than anything found on the Hell House tapes.
                </CardText>
                <Button
                  onClick={
                    () =>
                      this.props.appState.openAndPlay({
                        title: 'HHLLC ORIGINS: THE CARMICHAEL MANOR',
                        url: 'https://www.youtube.com/watch?v=Q_HLcTY15WY&ab_channel=Shudder',
                      })
                  }
                  outline
                  className="m-2"
                  size="lg"
                >
                  <i className="fa fa-play pr-2" />Watch Trailer
                </Button>
                <Button
                  onClick={
                    () =>
                      window.open(
                        'https://www.shudder.com/movies/watch/hell-house-llc-origins-the-carmichael-manor/603eac069b74403c',
                        '_blank',
                      )
                  }
                  outline
                  size="lg"
                  color="success"
                  className="m-2"
                >
                  <i className="fa fa-play pr-2" />Available on Shudder
                </Button>
              </CardBlock>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default HomeFeatures;



// WEBPACK FOOTER //
// ./src/HomeFeatures.js